import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ResetCookie"] */ "/var/www/tmp.bua_frontend/src/components/analytics/ResetCookie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileTableCheck"] */ "/var/www/tmp.bua_frontend/src/components/MobileTabletCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/tmp.bua_frontend/src/components/Partials/Header.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/reset.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/variables.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/typo.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/index.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/page.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/GridLayout.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/Ideenwettbewerb.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/Footer.module.scss");
